import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import {FaTruckMoving } from "react-icons/fa";
import cn from "classnames";

import { Page, Uploader, Input } from "ui/components";

import { Schedule } from "services/action";
import { formatDate } from "utilities/common";

const Clockin = ({ location }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateForm = useSelector((state) => state?.Form);
  const StateAuth = useSelector((state) => state?.Auth);

  const {
    schedule_at,
  } = location?.state;

  const [images, setImages] = React.useState([]);
  const [start_odo, setStartOdo] = React.useState();

  const generateCode = async() => {
    let code = StateAuth?.session?.name?.replaceAll(' ', '')
    let date = formatDate(new Date(), 'DDMMYYYYHHmmss')

    return code + date
  }

  const convertScheduleDate = () => {
    const str = schedule_at.split('/')

    return str[2] + '-' + str[1] + '-' + str[0]
  }

  const $onSubmit = async (e) => {
    let payload = {
      schedule_at: convertScheduleDate(),
      start_odo: start_odo,
      images: images,
    };

    const req = await Dispatch(Schedule.$tapIn(payload));
    if (req?.message === "success") {
      History.goBack();
    }
  };

  return (
    <Page
      title="Clockin"
      backTo={() => History.goBack()}
      action={
        <div>
          <Button
            type="button"
            variant="success"
            className={cn(
              "pe-4 ps-4 rounded w-100",
              StateForm?.loading ? "btn-loading" : ""
            )}
            onClick={$onSubmit}
          >
            Simpan
          </Button>
        </div>
      }
    >
      <div className="px-2 py-3">
        <Uploader
          images={images}
          errors={StateForm?.errors?.images}
          onChange={(e) => setImages(e)}
          type="clockin"
          code={generateCode()}
        />

        {StateForm?.errors?.id ? (
          <div
            className="text-center"
            style={{ marginBottom: 5, marginTop: 10 }}
          >
            <span style={{ color: "red" }}>{StateForm?.errors?.id}</span>
          </div>
        ) : null}

        <div className="py-3">
          <div>KM Awal:</div>
          <div className="form-group ">
            <Input
              icon={<FaTruckMoving />}
              value={start_odo}
              onChange={(e) => {
                setStartOdo(e.target.valueAsNumber);
              }}
              type="number"
              placeholder=""
              error={StateForm?.errors?.start_odo}
              lg
            />
          </div>
        </div>
      </div>
    </Page>
  );
};

export default Clockin;
